$(document).ready(function() {
  // Dinamic carousel indicators
  if ( $('.carousel').length > 0 ){
    var element = $(".carousel").attr('id');
    var myCarousel = $('#'+element);
    myCarousel.append("<ol class='carousel-indicators'></ol>");
    var indicators = $(".carousel-indicators"); 
    myCarousel.find(".carousel-inner").children(".item").each(function(index) {
        (index === 0) ? 
        indicators.append("<li data-target='#"+element+"' data-slide-to='"+index+"' class='active'></li>") : 
        indicators.append("<li data-target='#"+element+"' data-slide-to='"+index+"'></li>");
    });
  }
  // Window open to share
  $('.windowopen').on('click', function (e) {
    e.preventDefault();
    var winWidth = 520;
    var winHeight = 350;
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    window.open($(this).attr('href'), 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    return false;
  });
 
});